import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const progressBarComponent = {
  root: 'progress-bar.root',
} as const satisfies ComponentLocatorMap;
